import { QueryClient } from '@tanstack/react-query';
import type { ProductListQuery } from '@kon/shared';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx) — only transient failures.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

export const queryKeys = {
  products: (query: Partial<ProductListQuery>) => ['products', query] as const,
  featured: () => ['products', 'featured'] as const,
  product: (slug: string) => ['product', slug] as const,
  order: (id: string) => ['order', id] as const,
};
